import React from "react";

const AuthLayout = ({ children }) => {
  return <div className="auth-shell">{children}</div>;
};

export default AuthLayout;
